import { render, staticRenderFns } from "./TrQuery.vue?vue&type=template&id=26a07010&scoped=true&"
import script from "./TrQuery.vue?vue&type=script&lang=js&"
export * from "./TrQuery.vue?vue&type=script&lang=js&"
import style0 from "./TrQuery.vue?vue&type=style&index=0&id=26a07010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a07010",
  null
  
)

export default component.exports